import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import ExternalLink from '@material-ui/icons/Launch'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

require('./../../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/INSTAR_IP_Kamera_in_AVM_FritzFon_hinzufügen_für_LiveBild.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>Wir zeigen Ihnen in diesem Video wie Sie eine INSTAR HD IP Kamera in einem Fritz!Fon hinzufügen können um sich so auf dem Telefon das LiveBild der Kamera abzeigen zu lassen. Auf <OutboundLink href="https://www.youtube.com/watch?v=eRCrlHGhurc" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
            <p>!!ACHTUNG!!: Beim Videopfad muss noch ein <strong>/tmpfs/</strong> vor dem auto.jpg stehen. Also komplett z.B. <em>http://192.168.1.249:80/tmpfs/auto.jpg</em> Wir entschuldigen uns für den Fehler.</p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)